import { FETCH_OVERVIEW, LOAD_OVERVIEW } from '../Actions/Overview'

export const emptyContent = {
  _id: 'none',
  created: 0,
  contentType: '',
  title: '',
  totalViews: 1,
  totalViewsWeb: 0,
  totalViewsMobile: 0,
  avgViewDuration: 0,
  thumbnailUrl: '',
  totalLikes: 0,
  reactionCounts: [],
  totalReactions: 0,
  totalComments: 0,
  totalShares: 0,
  totalOfflineDownloads: 0,
  accountDetails: {}
}

const initialState = {
  totalRegistration: 0,
  registrationsChange: 0,
  newContent: 0,
  newContentChangePct: 0,
  mostViewedContent: emptyContent,
  registrationPct: 0,
  totalMembers: 0,
  totalRegisteredUsers: 0,
  totalRegisteredPctChange: 0,
  mostLikedContent: emptyContent,
  mostReactedContent: emptyContent,
  mostCommentedContent: emptyContent,
  totalLikesPctChange: 0,
  totalLogins: 0,
  totalLoginsPctChange: 0,
  avgMobileAppDuration: 0,
  avgMobileAppDurationChangePct: 0,
  avgWebAppDuration: 0,
  avgWebAppDurationChangePct: 0,
  absoluteTotalReg: 0,
  totalLicences: 0,
  activeUsers: 0,
  loading: true
}

/**
  * overviewReducer
  * @desc Action handler for Overview part of the redux state
  * @param {Object} state
  * @param {action} action
  * @return {Object} state updated redux state
*/
export default function overviewReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case FETCH_OVERVIEW:
      return Object.assign({}, state, { loading: true })
    case LOAD_OVERVIEW:
      return Object.assign({}, { ...action.data.accountSummary, loading: false })
    default:
      return state
  }
}
